/**
 * 封面色票(R245)— 對齊 D3 `projects-data.js` `PJ_COVERS` 八色
 * -----------------------------------------------------------------------------
 * ⚠️ **這裡的 hex 是「送去後端的資料值」,不是 UI 主題色** —— `cover.color` 會原樣
 * 進 `PATCH` body,BE 用 `^#[0-9a-fA-F]{6}$` 嚴驗。CSS 變數送不出去(後端拿到
 * `var(--tide-600)` 只會 422),所以這裡**必須**是字面 hex,`no-hardcoded-colors`
 * 的 disable 是有理由的,不是繞過。同型先例:`BrandKitCard` 的品牌色票展示值。
 *
 * 色盤由 FE 全權決定 —— BE 只驗格式,換色盤不需要動後端(docs/92 §2.1 明說)。
 *
 * `labelKey` 走 i18n(`common:cover.swatch.*`),不寫死中文。
 */

/*
 * ⚠️ `as const` 不是可有可無的:i18n 的 `t()` 是**強型別 key**,`labelKey` 一旦
 * widen 成 `string`,`t(`cover.swatch.${labelKey}`)` 就變成無限寬的 template
 * literal type、對不上 key union → tsc 直接紅。收成字面量 union 之後,少加一個
 * 翻譯 key 也會在編譯期被抓到(等於免費的完整性檢查)。
 */
/* eslint-disable hai/no-hardcoded-colors -- 封面色票是送往後端的資料值(cover.color 必須是字面 #RRGGBB,CSS 變數送不出去),非 UI 主題色 */
export const COVER_SWATCHES = [
  { id: 'pine', hex: '#134E4A', labelKey: 'pine' },
  { id: 'teal', hex: '#0D9488', labelKey: 'teal' },
  { id: 'slate', hex: '#334155', labelKey: 'slate' },
  { id: 'night', hex: '#312E81', labelKey: 'night' },
  { id: 'grape', hex: '#6B21A8', labelKey: 'grape' },
  { id: 'brick', hex: '#9F1239', labelKey: 'brick' },
  { id: 'caramel', hex: '#B45309', labelKey: 'caramel' },
  { id: 'olive', hex: '#3F6212', labelKey: 'olive' },
] as const;
/* eslint-enable hai/no-hardcoded-colors */

export type CoverSwatch = (typeof COVER_SWATCHES)[number];
